import React, {useState} from "react"
import { ReturnTextAndImg } from "../CheckImg";

export default function AssotiationAnswer({data, changeAssotiationsAnswer, isPassed, userAnswers}) {
  function shuffle(arr) {
    let array = arr.slice()
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array
  }

    const [state, setState] = useState({
    
    questions: shuffle(data.map(item => {
    return item.name
  })),
  })
  const symbols = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
  let counts = 0;
  const styles = {
    right: {
      border: '3px solid rgba(128, 253, 195, 0.76)',
      borderRadius: '10px',
    },
    wrongUser: {
      border: '3px solid rgba(253, 128, 128, 0.76)',
      borderRadius: '10px',
    },    
  }
  let style;

  const selectAssotiations = []
  const symbolsAnswers = []
  const variants = data.map((item,i) => {
    if (isPassed) {
      let right_object = data.find(element => element.name === state.questions[i])
      style = isPassed && userAnswers[right_object.name] === right_object.equal ? styles.right :
              isPassed && userAnswers[right_object.name] !== right_object.equal ? styles.wrongUser : null
    }
    const text =ReturnTextAndImg(state.questions[i]);
    counts++
    return (
    <div key={`keyVariant${item.name}`} className="test-assotiation-variant" style={style}>
      <select answername={state.questions[i]} onChange={(e) => changeAssotiationsAnswer(e)} disabled={isPassed}>
        <option>Выберите</option>
        {selectAssotiations}
      </select>
      {/* <p >{`${counts}`}</p> */}
      {text}
    </div>
    )
  })

  const assotiations = data.map((item, i) => {
    let text=ReturnTextAndImg(item.equal);
    selectAssotiations.push(<option key={`${i}-option`} value={item.equal}>{symbols[i]}</option>)
    symbolsAnswers.push(<p key={`keyforSA${i}`}>{symbols[i]}</p>)
    return (
      <tr key={'kkkkkkkkey'+item.equal+i}>
        <td  style={{padding:'0px 5px 0px 0px'}}>{variants[i]}</td>
        <td className="test-assotiations-symbols">{symbolsAnswers[i]}</td>
        <td>
          {text}
        </td>
        </tr>
  )})  
  
  return (
    <div className="test-asotiationtype">
          <div className="test-assotiation-asotiation">
            <div className="test-assotiations-answers">
              <table><tbody>{assotiations}</tbody></table>
            </div>
          </div>
    </div>
  )
}
